import DigitGrid from './DigitGrid';
import React from 'react';

const Digit = React.memo(( { value } ) => {

  const left = value[0];
  const right = value[1];

  return (
    <div className="digit-container animate-pop">
      <div className="digit digit-left">
        <DigitGrid value={left}/>
      </div>
      <div className="digit digit-right">
        <DigitGrid value={right}/>
      </div>
    </div>
  );
});

export default Digit;